var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketingMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05356 10.7549L8.63378 13.4359C8.68695 13.5259 8.71759 13.6274 8.7231 13.7317C8.7286 13.8361 8.70882 13.9402 8.66542 14.0353C8.62203 14.1304 8.5563 14.2136 8.47385 14.2778C8.3914 14.342 8.29465 14.3853 8.19185 14.4041L7.44339 14.536C7.18235 14.5826 6.91332 14.5482 6.67237 14.4375C6.43142 14.3268 6.23008 14.1451 6.09537 13.9167L4.20554 10.6777M8.81248 5.06643L9.48878 8.90193M12.6351 3.56855L14.1278 2.317M13.5932 9.00206L15.4239 9.6676M12.9862 6.30853L14.904 5.97038M9.80584 1.72788C8.92799 2.66156 7.854 3.38894 6.66122 3.85763L3.30046 5.16846C3.02086 5.27746 2.78757 5.47983 2.64019 5.74125C2.49281 6.00266 2.44041 6.30701 2.49189 6.60266L3.02394 9.62011C3.07149 9.92097 3.22316 10.1956 3.4525 10.396C3.68184 10.5965 3.97428 10.71 4.27879 10.7169L7.88533 10.7999C9.16245 10.8251 10.419 11.133 11.5642 11.7C11.6717 11.7545 11.7923 11.7779 11.9124 11.7677C12.0325 11.7574 12.1474 11.714 12.2442 11.6422C12.341 11.5704 12.4159 11.4731 12.4606 11.3611C12.5052 11.2491 12.5178 11.1269 12.4969 11.0082L10.9189 2.05896C10.898 1.94019 10.8445 1.82959 10.7643 1.73953C10.6841 1.64948 10.5804 1.58354 10.4648 1.5491C10.3493 1.51466 10.2264 1.51308 10.11 1.54454C9.99356 1.576 9.88832 1.63992 9.80584 1.72788Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingMaterial);
export default __webpack_public_path__ + "static/media/marketingMaterial.87c1e7aafbd4898b9b97bd5c7bad5cf1.svg";
export { ForwardRef as ReactComponent };